import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    Typography,
} from '@material-ui/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faExclamation,
} from '@fortawesome/pro-solid-svg-icons';
import './SidePanelDetails.scss';

/**
 * @param {{
 *  isShowSubmissionPeriod: boolean?,
 *  submissionStartDate: string?,
 *  submissionEndDate: string?,
 *  isShowManagerMessage: boolean?,
 *  managerMessage: string?,
 *  withHeader: boolean?,
 * }} props
 */
const SidePanelDetails = ({
    isShowSubmissionPeriod = false, submissionStartDate = '', submissionEndDate = '',
    isShowManagerMessage = false, managerMessage = '',
    isShowRestrictionDates = false, restrictionStartDate = '', restrictionEndDate = '', restrictedEmployeeName = '', withHeader = true,

}) => {
    const { t } = useTranslation('employmentBillboard', { keyPrefix: 'employeeSidePanel.details' });

    return (
        <div className="side-panel--details">
            {withHeader ? <h1 className="side-panel--header">{t('header')}</h1> : null}
            <div className="details-wrapper">
                {isShowManagerMessage && <ManagerMessage
                    managerMessage={managerMessage}
                    t={t}
                />}
                {isShowSubmissionPeriod && <SubmissionPeriod
                    submissionStartDate={submissionStartDate}
                    submissionEndDate={submissionEndDate}
                    t={t}
                />}
                {isShowRestrictionDates && <RestrictionPeriod
                    restrictionStartDate={restrictionStartDate}
                    restrictionEndDate={restrictionEndDate}
                    restrictedEmployeeName={restrictedEmployeeName}
                    t={t}
                />}
            </div>
        </div>
    );
}

/**
 * @param {{ submissionStartDate: string, submissionEndDate: string, t: * }} props
 */
const SubmissionPeriod = ({ submissionStartDate, submissionEndDate, t }) => (
    <div className="spd-submission-period">
        <span>{`${t('submissionStart')}: ${submissionStartDate}`}</span>
        <span>{`${t('submissionEnd')}: ${submissionEndDate}`}</span>
    </div>
);

/**
 * @param {{ submissionStartDate: string, submissionEndDate: string, t: * }} props
 */
const ManagerMessage = ({ managerMessage, t }) => (<>
    {managerMessage ? managerMessage : <span style={{ color: '#c1c1c1' }}>No details from manager available</span>}
</>);

/**
 * @param {{ restrictionStartDate: string, restrictionEndDate: string, restrictedEmployeeName: string, t: * }} props
 */
 const RestrictionPeriod = ({ restrictionStartDate, restrictionEndDate, restrictedEmployeeName, t }) => (
    <div className="spd-submission-period">
        <Typography component='div' style={{ width: '100%', padding: '5px 10px', backgroundColor: '#FFFFFF', border: '1px solid #FF7300', borderRadius: 4 }}>
            <FontAwesomeIcon icon={faExclamation} /> {restrictedEmployeeName} is on restriction period from {restrictionStartDate} to {restrictionEndDate}
        </Typography>
    </div>);

export default SidePanelDetails;
